import { render, staticRenderFns } from "./register-doctor.vue?vue&type=template&id=6cdd16f2&"
import script from "./register-doctor.vue?vue&type=script&lang=js&"
export * from "./register-doctor.vue?vue&type=script&lang=js&"
import style0 from "./register-doctor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports